// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { PrivateBenchmarkDataFromJSON, PrivateBenchmarkDataToJSON, PrivateBenchmarkSummaryFromJSON, PrivateBenchmarkSummaryToJSON, } from './';
export function PrivateBenchmarkResponseFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'summary': !exists(json, 'summary') ? undefined : PrivateBenchmarkSummaryFromJSON(json['summary']),
        'data': !exists(json, 'data') ? undefined : json['data'].map(PrivateBenchmarkDataFromJSON),
    };
}
export function PrivateBenchmarkResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'summary': PrivateBenchmarkSummaryToJSON(value.summary),
        'data': value.data === undefined ? undefined : value.data.map(PrivateBenchmarkDataToJSON),
    };
}
